import { useHeadersContext } from "@/providers";
import { getMirrorsDataByHost } from "@/utils/getMirrorsDataByHost";

export const useCompany = () => {
  const { host } = useHeadersContext();

  return getMirrorsDataByHost(host);
};
